  export function processHtmlContent(htmlContent: string): string {

    if (!htmlContent || htmlContent.trim() === '') {
      return 'Enter custom paragraph';
    }

    const element = document.createElement('div');
    element.innerHTML = htmlContent;

    const links = element.querySelectorAll('a');
    links.forEach(link => {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });

    return element.innerHTML;
  };    